//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import CommonCart from "../../../components/common/common.cart";
import CommonSummary from "../../../components/common/common.summary";

export default function CartBasic() {
  const { cartInfoLoading, cartInfo } = useSelector((state) => state.cart);

  return (
    <Container className="cart-basic">
      <Col className="pt-4 pb-4 px-4">
        <Row className="_row title">
          <h1 className="_label your-cart">Your Cart</h1>
          <p className="_label item-count">
            {!cartInfoLoading ? cartInfo?.total_item : ""} Item(s)
          </p>
        </Row>
        <Col className="_col cart-item-list">
          {cartInfoLoading
            ? Array.from({ length: 2 }, (_, cartLoadingIndex) => (
                <CommonCart loading key={cartLoadingIndex} />
              ))
            : cartInfo?.items?.length > 0 &&
              cartInfo.items.map((cart, cartIndex) => (
                <CommonCart data={cart} key={cartIndex} />
              ))}
        </Col>
      </Col>
      <CommonSummary loading={cartInfoLoading} data={cartInfo} />
    </Container>
  );
}
